import { useContext } from 'react';
import { AjusteDeParaContextData } from '../types/context';
import { AjusteDeParaContext } from '../context/ajusteDeParaContext';

export const useAjusteDePara = (): AjusteDeParaContextData =>
  useContext(AjusteDeParaContext);
